import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip23',
  imgSrc: 'card/template/vip00/cardTemplateVip23.png',
  desc: '棕榈',
  category: 'card',
  vipGrade: 0,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/scene10.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/palmy.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
